/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        //burger menu
        var bigSlideAPI = $('.hamburger-menu').bigSlide({
          menu: '#mobile-side-nav',
          push: '.push',
          side: 'left', 
          speed: 200,
          easyClose: true,
          menuWidth: '15.625em', 
          beforeOpen: function(){
            $('.bar').toggleClass('animate');
            $('body').toggleClass('cover'); 
          },
          beforeClose: function(){
            $('.bar').toggleClass('animate');
            $('body').toggleClass('cover');
          }
        }).bigSlideAPI;
        $('.nav-primary ul li a, .nav-primary ul li').on('click',function() {
          bigSlideAPI.view.toggleClose();
        });  

/*
        var menuOffset = $('.header').offset();
        $(window).scroll(function () {
          var docScroll = $(document).scrollTop() - 1;
          if (docScroll >= menuOffset.top) {
            $('.header').addClass('fixed');
            $('body').addClass('added');
          } else {
            $('.header').addClass('fixed');  
            $('body').addClass('added');         
          }
        });
*/
        // init Isotope
        var $container = $('.grid').isotope({
            itemSelector: '.element-item',
            layoutMode: 'fitRows'
        });

        // filter functions
        var filterFns = {
          // show if number is greater than 50
          numberGreaterThan50: function() {
            var number = $(this).find('.number').text();
            return parseInt( number, 10 ) > 50;
          }
        };

        // bind filter button click
        $('#filters').on( 'click', 'li', function() {
          var filterValue = $( this ).attr('data-filter');
            if(filterValue == '*') {
              $('div.duplicate').addClass('hide');
            } else {
              $('div.duplicate').removeClass('hide');
            }
            // use filterFn if matches value
            filterValue = filterFns[ filterValue ] || filterValue;
            $container.isotope({ filter: filterValue });
        });
        
        // change is-checked class on buttons
        $('.button-group').each( function( i, buttonGroup ) {
          var $buttonGroup = $( buttonGroup );
          $buttonGroup.on( 'click', 'li', function() {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $( this ).addClass('is-checked');
          });
        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
